import React from 'react';
import { withTranslation } from 'react-i18next';
import { Dropdown } from 'wix-ui-tpa';
import { st, classes } from './Tabs.st.css';
import {
  CategoriesListBlock,
  OptionsContainerBlock,
  TitleContainerBlock,
  CusttomScrollBar,
} from './Tabs.style.js';
import { connect } from 'react-redux';

class Tabs extends React.Component {
  constructor(props) {
    super(props);
    this.dropdownList = [];
    this.searchResult = '';
    this.tabs = props.children || [];
    this.state = {
      inited: false,
      catDropdownInitialSelectedId: 'tab0',
      tabs: props.children || [],
      selected: this.tabs.find((tab) => tab.props.selected) || this.tabs[0],
      styleParams: props.styleParams,
    };

    this.selectTab = this.selectTab.bind(this);
    this.previousTab = this.previousTab.bind(this);
    this.nextTab = this.nextTab.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleKeyup = this.handleKeyup.bind(this);
    this.selectDropdownItem = this.selectDropdownItem.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.children !== prevProps.children) {
      this.tabs = this.props.children || [];

      this.setState({
        tabs: this.tabs,
        inited: true,
        selected: this.tabs.find((tab) => tab.props.selected) || this.tabs[0],
      });
    }
    if (this.props.styleParams !== prevProps.styleParams) {
      this.setState({ styleParams: this.props.styleParams });
    }
  }

  selectTab(tab, isDropDown) {
    if (isDropDown !== true) {
      this.dropdownList.map((item, index) => {
        if (item.tab === tab) {
          const catDropdownInitialSelectedId = index + '';
          this.setState({
            selected: tab,
            catDropdownInitialSelectedId,
          });
        }
        return [];
      });
    } else {
      this.setState({
        selected: tab.tab,
        inited: true,
        catDropdownInitialSelectedId: tab.id,
      });
    }
  }
  previousTab(tab) {
    const index = this.state.tabs.indexOf(tab);
    if (index > 0) {
      this.selectTab(this.state.tabs[index - 1]);
    }
  }

  nextTab(tab) {
    const index = this.state.tabs.indexOf(tab);
    if (index < this.state.tabs.length - 1) {
      this.selectTab(this.state.tabs[index + 1]);
    }
  }

  handleClick(e, tab) {
    e.preventDefault();
    e.stopPropagation();

    this.selectTab(tab);
  }
  moveTabFocus(e, isRTL) {
    const tabs = document.querySelectorAll("[role='tab']");
    const tabsArr = [];
    tabs.forEach((tab) => {
      tabsArr.push(tab.id);
    });

    const isFirst = (id) => (tabsArr[0] === id ? true : false);
    const isLast = (id) => (tabsArr[tabsArr.length - 1] === id ? true : false);
    const moveNext = (id) => tabs[tabsArr.indexOf(id) + 1].focus();
    const movePrevious = (id) => tabs[tabsArr.indexOf(id) - 1].focus();
    if (isRTL) {
      if (e.keyCode === 37 && !isLast(e.target.id)) {
        moveNext(e.target.id);
      }
      if (e.keyCode === 39 && !isFirst(e.target.id)) {
        movePrevious(e.target.id);
      }
    } else {
      if (e.keyCode === 37 && !isFirst(e.target.id)) {
        movePrevious(e.target.id);
      }
      if (e.keyCode === 39 && !isLast(e.target.id)) {
        moveNext(e.target.id);
      }
    }
  }
  selectTabOnKeyPress(e) {
    const panels = document.querySelectorAll("[role='tabpanel']");
    const panelsArr = [];
    panels.forEach((panel) => panelsArr.push(panel.id));
    const panel = document.getElementById(e.target.dataset.control);
    if (panel) {
      // inert all panels, uninert current panel
      // eslint-disable-next-line no-shadow
      panels.forEach((panel) => {
        if (panel.id === e.target.dataset.control) {
          panel.inert = false;
          panel.setAttribute('aria-hidden', false);
        } else {
          panel.inert = true;
          panel.setAttribute('aria-hidden', true);
        }
      });
    }
  }
  handleKeyup(e, tab, isRTL) {
    e.preventDefault();
    e.stopPropagation();
    // only move focus
    if (e.keyCode === 37 || e.keyCode === 39) {
      this.moveTabFocus(e, isRTL);
    }

    if (e.which === 13 || e.which === 32) {
      this.selectTabOnKeyPress(e);
      this.selectTab(tab);
    }
  }
  selectDropdownItem(option) {
    this.selectTab(option, true);
  }

  render() {
    const { tabs, styleParams } = this.state;
    const { design, settings, t, i18n } = this.props;

    const tabClassName = settings.isRTL
      ? st(classes.tabRight)
      : st(classes.tabLeft);
    this.dropdownList = [];

    let categoriesTabClasses = 'categories-tab-list ';
    let flexGrowClasses = '';
    if (settings.isFixedHeight) {
      categoriesTabClasses += 'flex-column box-categories';
      flexGrowClasses =
        'flex-column flexbox-grow fixedScrollbar ' +
        (settings.isRTL ? 'paddingLeft ' : 'paddingRight');
    }

    return (
      <>
        <div className={categoriesTabClasses}>
          <ul
            aria-label={t('navigate.tabs.aria.label')}
            role="tablist"
            className={st(
              classes.tabList,
              classes[settings.layout],
              'categories-block',
            )}
          >
            {tabs.map((tab, i) => {
              this.dropdownList.push({
                id: `tab${i}`,
                title: tab.props.title,
                label: tab.props.title,
                value: tab.props.title,
                tab,
                weight: i,
                isSelectable: 1,
              });

              const isSelectedClassName =
                tab === this.state.selected
                  ? st(classes.isSelected) + ' active'
                  : '';
              const tabClasses = tabClassName + ' ' + isSelectedClassName;

              return (
                <li
                  role="tab"
                  id={`tab${i}`}
                  onKeyUp={(e) => this.handleKeyup(e, tab, settings.isRTL)}
                  className={st(classes.tabItem)}
                  data-control={`panel${i}`}
                  aria-controls={`tab${i}`}
                  aria-selected={tab === this.state.selected}
                  tabIndex={tab === this.state.selected ? 0 : -1}
                  onClick={(e) => this.handleClick(e, tab)}
                  ref={(link) => {
                    if (tab === this.state.selected) {
                      this.activeLink = link;
                    }
                  }}
                >
                  <TitleContainerBlock
                    className={tabClasses}
                    design={design}
                    styleParams={styleParams}
                    settings={settings}
                    isCategoryOtherTextColor={
                      !!styleParams.colors?.categoryOtherTextColor
                    }
                    isSelectedCategoryChanged={
                      !!styleParams.booleans?.isSelectedCategoryChanged
                    }
                    isCategoryChanged={
                      !!styleParams.booleans?.isCategoryChanged
                    }
                    isSelectedCategoryTextColor={
                      !!styleParams.colors?.selectedCategoryTextColor
                    }
                  >
                    {tab.props.title}
                  </TitleContainerBlock>
                </li>
              );
            })}
          </ul>
        </div>
        <CategoriesListBlock
          className={st(classes.categoriesList)}
          styleParams={styleParams}
          design={design}
          settings={settings}
          isCategoryOtherTextColor={
            !!styleParams.colors?.categoryOtherTextColor
          }
          isSelectedCategoryChanged={
            !!styleParams.booleans?.isSelectedCategoryChanged
          }
          isSelectedCategoryTextColor={
            !!styleParams.colors?.selectedCategoryTextColor
          }
        >
          {/* // label tag for A11y purpose  */}
          <label>
            <div>
              {i18n.exists('mobile.choose.category.label')
                ? t('mobile.choose.category.label')
                : 'Choose a category'}
            </div>
            <Dropdown
              onExpandedChange={() => {}}
              onChange={(option) => {
                this.selectDropdownItem(option);
              }}
              className={st(classes.root, classes.dropdownListBox)}
              placement="bottom"
              options={this.dropdownList}
              initialSelectedId={this.state.catDropdownInitialSelectedId}
              appendTo={classes.dropdownListBox}
              optionsContainerId="optionsContainerBlock"
              flip={false}
              mobileNativeSelect
            />
          </label>
          <OptionsContainerBlock
            styleParams={styleParams}
            design={design}
            settings={settings}
          >
            <section id="optionsContainerBlock" />
          </OptionsContainerBlock>
        </CategoriesListBlock>
        <CusttomScrollBar
          className={flexGrowClasses}
          styleParams={styleParams}
          design={design}
          settings={settings}
        >
          {tabs.map((tab, i) =>
            React.cloneElement(tab, {
              index: i,
              isSelected: () => tab === this.state.selected,
            }),
          )}
        </CusttomScrollBar>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state,
  };
}

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(Tabs));
